import { render, h, Fragment } from 'preact';
import FormStepLayout from '../../templates/FormStepLayout/FormStepLayout';
import useFormStore from '../../store/useFormStore';
import FranchiseInfoBlock from '../../components/blocks/FranchiseInfoBlock';
import UserInformationReviewBlock from '../../components/blocks/UserInformationReviewBlock';
import CartBlock from '../../components/cart/CartBlock';
import PrintableConfirmation from '../../components/print/PrintableConfirmation';
import AppointmentDetailsList from '../../components/appointments/AppointmentDetailsList';
import ShortLeadInfoBlock from '../../components/blocks/ShortLeadInfoBlock';

export default function Confirmation({}) {
  const selectedEstimateType = useFormStore((state) => state.selectedEstimateType);
  const currentFranchise = useFormStore((state) => state.currentFranchise);
  const isShortLeadForm = selectedEstimateType === 'on_site_estimate_short';

  // Get confirmation messages from franchise estimate type configuration
  const confirmationConfig = currentFranchise?.form_type?.[selectedEstimateType]?.confirmation;
  const confirmationTitle = confirmationConfig?.title || "Thank you!";
  const confirmationSubtitle = confirmationConfig?.subtitle || "You will receive an email shortly.";

  return (
    <>
      {/* Hidden printable component */}
      <PrintableConfirmation />

      <FormStepLayout
        title={confirmationTitle}
        subtitle={confirmationSubtitle}
        showProgress={false}
        showBackButton={false} // Chage to true if we want to allow going back from confirmation page. Test Submissions
        showMobileNav={false}
        showPrint={false} // Hiding print for now
        showPromotionsBlock={false}
      >

        <div className="mx-auto grid grid-cols-12 gap-6 print:hidden">
        <aside className={`col-span-12 xl:col-span-3 order-3 xl:order-1 flex flex-col gap-3.5`}>
          <FranchiseInfoBlock />
        </aside>
        <div className="col-span-12 xl:col-span-9 order-1">

          <div className="flex flex-col gap-4">
            {isShortLeadForm ? (
              <ShortLeadInfoBlock />
            ) : (
              <Fragment>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <AppointmentDetailsList />
                </div>
                <CartBlock />
              </Fragment>
            )}
            <div className="bg-white p-6 shadow-sm">
              <div className="text-2xl font-bold mb-6">
                Your Contact Information
              </div>
              <UserInformationReviewBlock />
            </div>
          </div>
        </div>
      </div>
    </FormStepLayout>
    </>
  );
}
